import {
	Modal,
	MimaInput,
	MimaText,
	MimaButton,
	MimaDropdown,
	ReceiptCheckBox as RCB,
	MimaDateInput,
} from '../../components';
import styles from '../../assets/styles/Commission/Commission.module.scss';
import { amountFormatter } from '../../utils/utils';
import { Formik, Field, FieldArray } from 'formik';
import React from 'react';

const CreateComType = ({
	closeModal,
	loading,
	validationSchema,
	onSubmit,
	customers,
}) => {
	return (
		<Modal closeModal={closeModal}>
			<MimaText
				variant="subtitle"
				color="var(--color-primary)"
				align="center"
				mb={3}
			>
				Create Commission Type
			</MimaText>
			<Formik
				initialValues={{
					name: '',
					targetType: '',
					deductTax: '',
					target: '',
					baseTarget: '',
					commissionTarget: '',
					commissionCalculation: '',
					rate: 0,
					fixedAmount: 0,
					pointValue: 0,
					disbursementPeriod: '',
					payDayOfMonth: ''
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}
			>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<div>
						<MimaInput
							type="text"
							labelTitle="Commission type Name"
							placeholder="Commission Name"
							min={0}
							name="name"
							value={values.name}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.name}
							touched={touched.name}
						/>

						<>
							<MimaText variant="small" mt={2} ml={2}>
								Target type
							</MimaText>
							<div className="modal__checks">
								<RCB
									title="Volume"
									onChange={() => {
										setFieldValue('targetType', 'VOLUME');
									}}
									checked={values.targetType === 'VOLUME'}
									name="targetType"
								/>
								<RCB
									title="Value"
									checked={values.targetType === 'VALUE'}
									onChange={() => setFieldValue('targetType', 'VALUE')}
									name="targetType"
								/>
							</div>
							{errors.targetType ? (
								<div className={styles.error}>
									{''}
									{touched.targetType && errors.targetType}
									{''}
								</div>
							) : null}
						</>

						<>
							<MimaText variant="small" mt={2} ml={2}>
								Deduct tax
							</MimaText>
							<div className="modal__checks">
								<RCB
									title="Yes"
									onChange={() => {
										setFieldValue('deductTax', 'YES');
									}}
									checked={values.deductTax === 'YES'}
									name="deductTax"
								/>
								<RCB
									title="No"
									checked={values.deductTax === 'NO'}
									onChange={() => setFieldValue('deductTax', 'NO')}
									name="deductTax"
								/>
							</div>
							{errors.deductTax ? (
								<div className={styles.error}>
									{''}
									{touched.deductTax && errors.deductTax}
									{''}
								</div>
							) : null}
						</>

						<>
							<MimaText variant="small" mt={2} ml={2}>
								Commission Calculation
							</MimaText>
							<div className="modal__checks">
								<RCB
									title="Target Comparison"
									onChange={() => {
										setFieldValue('calculation', 'TARGET-COMPARISON');
									}}
									checked={values.calculation === 'TARGET-COMPARISON'}
									name="calculation"
								/>
								<RCB
									title="Basic Rate"
									checked={values.calculation === 'BASIC'}
									onChange={() => setFieldValue('calculation', 'BASIC')}
									name="calculation"
								/>
							</div>
							<div className="modal__checks">
								<RCB
									title="Fixed Amount"
									onChange={() => {
										setFieldValue('calculation', 'FIXED');
									}}
									checked={values.calculation === 'FIXED'}
									name="calculation"
								/>
								<RCB
									title="Point Value"
									checked={values.calculation === 'POINT'}
									onChange={() => setFieldValue('calculation', 'POINT')}
									name="calculation"
								/>
							</div>
							{errors.calculation ? (
								<div className={styles.error}>
									{''}
									{touched.calculation && errors.calculation}
									{''}
								</div>
							) : null}
						</>
						{values.calculation === 'BASIC' ? (
							<>
								<MimaInput
									type="number"
									labelTitle="Basic Rate"
									placeholder="0.00"
									min={0}
									name="rate"
									value={values.rate}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.rate}
									touched={touched.rate}
								/>
								<MimaText
									width={38}
									labelTitle="Basic Rate Calculation"
									variant="bodyBold"
									mb={2}
								>
									Commission = (Total Achieved * Commission Rate)/100
								</MimaText>
							</>
						) : values.calculation === 'FIXED' ? (
							<MimaInput
								type="number"
								labelTitle="Fixed Amount"
								placeholder="0.00"
								min={0}
								name="fixedAmount"
								value={values.fixedAmount}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.fixedAmount}
								touched={touched.fixedAmount}
							/>
						) : values.calculation === 'POINT' ? (
							<MimaInput
								type="number"
								labelTitle="Point Value"
								placeholder="0.00"
								min={0}
								name="pointValue"
								value={values.pointValue}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.pointValue}
								touched={touched.pointValue}
							/>
						) : values.calculation === 'TARGET-COMPARISON' ? (
							<>
								<MimaInput
									type="number"
									labelTitle="Target"
									placeholder="0.00"
									min={0}
									name="target"
									value={values.target}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.target}
									touched={touched.target}
								/>

								<MimaInput
									type="number"
									labelTitle="Base Target"
									placeholder="0.00"
									min={0}
									name="baseTarget"
									value={values.baseTarget}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.baseTarget}
									touched={touched.baseTarget}
								/>

								<MimaInput
									type="number"
									labelTitle="Commission Target"
									placeholder="0.00"
									min={0}
									name="commissionTarget"
									value={values.commissionTarget}
									onChange={handleChange}
									onBlur={handleBlur}
									error={errors.commissionTarget}
									touched={touched.commissionTarget}
								/>

								<MimaInput
									type="number"
									labelTitle="Basic Rate"
									placeholder="0.00"
									min={0}
									name="rate"
									value={values.rate}
									onChange={handleChange}
									onBlur={handleBlur}
									mb={2}
									error={errors.rate}
									touched={touched.rate}
								/>
								<MimaText
									width={38}
									labelTitle="Target Comparison Calculation"
									mb={2}
									variant="bodyBold"
								>
									Commission = (Total Achieved – Base Target)/Commission Target
									* (Commission Target * Commission Rate)
								</MimaText>
							</>
						) : (
							''
						)}

						<>
							<MimaText variant="small" mt={2} ml={2}>
								Disbursement Period
							</MimaText>
							<div className="modal__checks">
								<RCB
									title="Monthly"
									onChange={() => {
										setFieldValue('deductTax', 'MONTHLY');
									}}
									checked={values.disbursementPeriod === 'MONTHLY'}
									name="disbursementPeriod"
								/>
								<RCB
									title="Weekly"
									checked={values.disbursementPeriod === 'WEEKLY'}
									onChange={() => setFieldValue('disbursementPeriod', 'WEEKLY')}
									name="disbursementPeriod"
								/>
							</div>
							{errors.disbursementPeriod ? (
								<div className={styles.error}>
									{''}
									{touched.disbursementPeriod && errors.disbursementPeriod}
									{''}
								</div>
							) : null}
						</>

						{/* <>
							<MimaText variant="small" mt={2} ml={2}>
								Recurring Commission
							</MimaText>
							<div className="modal__checks">
								<RCB
									title="Yes"
									onChange={() => {
										setFieldValue('recurringCommission', 'YES');
									}}
									checked={values.recurringCommission === 'YES'}
									name="recurringCommission"
								/>
								<RCB
									title="No"
									checked={values.recurringCommission === 'NO'}
									onChange={() => setFieldValue('recurringCommission', 'NO')}
									name="recurringCommission"
								/>
							</div>
							{errors.recurringCommission ? (
								<div className={styles.error}>
									{''}
									{touched.recurringCommission && errors.recurringCommission}
									{''}
								</div>
							) : null}
						</> */}

						<MimaButton
							title="Create Commission Type"
							type="submit"
							loading={loading}
							onClick={handleSubmit}
							mt={2}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default CreateComType;
